import React, { useEffect, useContext, useState, useRef } from "react";

import {
  Alert,
  Autocomplete,
  Box,
  Button,
  Drawer,
  FormControl,
  FormLabel,
  Grid,
  IconButton,
  InputLabel,
  List,
  ListItem,
  ListItemText,
  MenuItem,
  OutlinedInput,
  Select,
  SelectChangeEvent,
  Snackbar,
  TextField,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { appLogger, Http } from "../../../src/utils";
import { UserContext } from "../../context/userContext";
import { UserLoginInfo } from "../../types/context";
import {
  ROLE_USER_ADMIN,
  ROLE_USER_MANAGER,
  ROLE_USER_MEMBER,
  ROLE_USER_SUPERADMIN,
  UserInfo,
} from "../../model";
import Divider from "@mui/material/Divider";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import Avatar from "@mui/material/Avatar";
import ThumbUpOffAltIcon from "@mui/icons-material/ThumbUpOffAlt";
import ThumbDownOffAltIcon from "@mui/icons-material/ThumbDownOffAlt";
interface IProps {
  editOpen: boolean;
  editID: UserInfo;
  addOpen: boolean;
  setEditPopup: Function;
  setClosePopup: Function;
  productLists?: [];
}

const ArticleQuesopen = (props: IProps) => {
  appLogger.info({
    infoObj: {
      method: "ArticleQuesopen",
      component: "users",
      fileName: "userForm.tsx",
      props: props,
    },
  });
  const { productLists } = props;
  const [open, setOpen] = useState(false);
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  // const [phone, setPhone] = useState("");
  const [userId, setUserId] = useState("");
  const [role, setRole] = useState("");
  const [selectedImage, setSelectedImage] = useState<any | null>(null);
  const [imageUrl, setImageUrl] = useState<any | null>(null);
  const [editUser, setEditUser] = useState<any | null>(null);
  const [alertOpen, setAlertOpen] = React.useState(false);
  const [errorAlertOpen, setErrorAlertOpen] = React.useState(false);
  const [editForm, setEditForm] = useState(false);
  const [addForm, setAddForm] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [isLoading, setIsloading] = React.useState(false);
  const [isManager, setIsManager] = useState(false);
  const [userProductRolerowsData, setuserProductRolerowsData] = useState<any>(
    []
  );
  const [orgRole, setOrgRole] = useState("");

  const [listItems, setListItems] = useState(
    Array.from(Array(10).keys(), (n) => n + 1)
  );
  const [isFetching, setIsFetching] = useState(false);

  // useEffect(() => {
  //   window.addEventListener("scroll", handleScroll);
  //   return () => window.removeEventListener("scroll", handleScroll);
  // }, []);

  const scrollableDiv: any = document.getElementById("articles-element");
  if (scrollableDiv) {
    // Add scroll event listener to the div
    scrollableDiv.addEventListener("scroll", function () {
      loadData();
    });
  }
  const loadData = () => {
    // Check if the user has scrolled to the bottom
    const diff = difference(
      scrollableDiv.scrollTop + scrollableDiv.clientHeight,
      scrollableDiv.scrollHeight
    );
    if (diff < 5) {
      // alert("Scroll Ends Here");
      setIsFetching(true);
    }
  };
  function difference(first: any, sec: any) {
    return Math.abs(first - sec);
  }
  useEffect(() => {
    if (!isFetching) return;
    fetchMoreListItems();
  }, [isFetching]);

  const handleScroll = () => {
    // if (
    //   window.innerHeight + Math.round(window.scrollY) >=
    //     document.body.offsetHeight ||
    //   isFetching
    // ) {
    //   alert("dddd");
    //   // you're at the bottom of the page
    //   setIsFetching(true);
    // }
  };

  const fetchMoreListItems = () => {
    setTimeout(() => {
      setListItems((prevState) => [
        ...prevState,
        ...Array.from(Array(20).keys(), (n) => n + prevState.length + 1),
      ]);
      setIsFetching(false);
    }, 2000);
  };

  const selectOrgRole = (event: SelectChangeEvent) => {
    setOrgRole((event.target as HTMLInputElement).value);
  };

  useEffect(() => {
    setOpen(props.editOpen);
    setEditUser(props.editID);
    setEditForm(props.editOpen);
    setAddForm(props.addOpen);

    if (props.addOpen) {
      setOrgRole("Member");
    }
  }, [props]);

  useEffect(() => {
    if (editForm) {
      setFirstName(editUser.nameFirst);
      setLastName(editUser.nameLast);
      setEmail(editUser.emailId);
      setUserId(editUser.id);
      if (editUser && editUser.userRole && editUser.userRole.length) {
        setOrgRole(editUser.userRole);
      }
    }
  }, [editForm]);

  const handleDrawerClose = () => {
    setOpen(false);
    props.setEditPopup(false);
    props.setClosePopup(false);

    setFirstName("");
    setLastName("");
    setEmail("");
    setRole("");
    setUserId("");
    // setPhone("");
    setImageUrl(null);
    setSelectedImage(null);
    setEditUser(null);
  };

  const selectRole = (event: SelectChangeEvent) => {
    setRole((event.target as HTMLInputElement).value);
  };

  const handleFirstName = (e: any) => {
    setFirstName(e.target.value);
  };

  const handleLastName = (e: any) => {
    setLastName(e.target.value);
  };

  const handleEmailChange = (e: any) => {
    setEmail(e.target.value);
  };
  // const handlePhoneChange = (e: any) => {
  //   setPhone(e.target.value);
  // };
  useEffect(() => {
    if (selectedImage) {
      setImageUrl(URL.createObjectURL(selectedImage));
    }
  }, [selectedImage]);

  const userResponse = {
    nameFirst: firstName,
    nameLast: lastName,
    emailId: email,
    active: true,
    userRole: orgRole,
    profilePic: imageUrl,
  };

  const { userInfo } = useContext(UserContext) as UserLoginInfo;

  const createUser = (values: any) => {
    if (!firstName || !lastName || !email || !orgRole) {
      setErrorAlertOpen(true);
      setSnackbarMessage("Please fill all the required fields.");
      return;
    }

    setIsloading(true);

    if (editForm) {
      try {
        Http.put({
          url: `/api/v2/users/`,
          body: {
            id: userId,
            emailId: email.toLowerCase(),
            nameFirst: firstName,
            nameLast: lastName,
            userRole: orgRole,
          },
          state: userInfo,
        })
          .then((response) => {
            const data: any = response;
            setSnackbarMessage("User edited successfully!!!");
            setAlertOpen(true);
            setIsloading(false);

            setTimeout(() => {
              setAlertOpen(false);
              handleDrawerClose();
            }, 1000);
          })
          .catch((err) => {
            setErrorAlertOpen(true);
            setSnackbarMessage("User edit failed.");
            setIsloading(false);
            appLogger.error({
              errObj: {
                method: "createUser",
                component: "users",
                fileName: "userForm.tsx",
                err: err,
              },
            });
          });
      } catch (error) {
        appLogger.error({
          errObj: {
            method: "createUser",
            component: "users",
            fileName: "userForm.tsx",
            err: error,
          },
        });
        setIsloading(false);
      }
    } else {
      try {
        let orgId = "";
        if (
          userInfo &&
          userInfo.userDetails &&
          userInfo.userDetails.userRole === ROLE_USER_SUPERADMIN
        ) {
          orgId = userInfo.userDetails.orgId || "";
        }
        Http.post({
          url: `/api/v2/users`,
          body: {
            nameFirst: firstName,
            nameLast: lastName,
            emailId: email.toLowerCase(),
            id: userId,
            orgId: orgId,
            active: true,
            userRole: orgRole,
          },
          state: userInfo,
        })

          .then((response) => {
            const data: any = response;
            setSnackbarMessage("user created successfully!!!");
            setAlertOpen(true);
            setIsloading(false);

            setTimeout(() => {
              setAlertOpen(false);
              handleDrawerClose();
            }, 1000);
          })
          .catch((err) => {
            setSnackbarMessage(
              JSON.parse(JSON.stringify(err))?.apiError?.msg ||
                "Create user failed!!!"
            );
            setErrorAlertOpen(true);
            setIsloading(false);
            appLogger.error({
              errObj: {
                method: "createUser",
                component: "users",
                fileName: "userForm.tsx",
                err: err,
              },
            });
          });
      } catch (error) {
        setIsloading(false);
        appLogger.error({
          errObj: {
            method: "createUser",
            component: "users",
            fileName: "userForm.tsx",
            err: error,
          },
        });
      }
    }
  };

  const handleAlertClose = () => {
    setAlertOpen(false);
  };

  const handleErrorAlertClose = () => {
    setErrorAlertOpen(false);
  };

  const addTableRows = () => {
    const subGroupInputs: any = {
      groupName: "",
      productIds: [],
    };
    setuserProductRolerowsData([...userProductRolerowsData, subGroupInputs]);
  };

  const deleteTableRows = (index: any) => {
    const rows = [...userProductRolerowsData];
    rows.splice(index, 1);
    setuserProductRolerowsData(rows);
  };

  const handleChange = (index: any, evnt: any, type: any) => {
    const subGroupInputs: any = [...userProductRolerowsData];
    if (type != "product") {
      const { name, value } = evnt.target;
      subGroupInputs[index][name] = value;
    } else {
      subGroupInputs[index]["productIds"] = evnt;
    }
    setuserProductRolerowsData(subGroupInputs);
  };

  return (
    <Grid>
      <Drawer
        PaperProps={{ id: "articles-element" }}
        className="user-popup articles"
        anchor="right"
        open={props.editOpen || props.addOpen}
        onClose={handleDrawerClose}
      >
        <Box sx={{ width: "100%" }}>
          <Box
            className="title-wrap"
            sx={{
              display: "flex",
              alignItems: "center",
              borderBottom: 1,
              borderColor: "divider",
            }}
          >
            <Typography className="title">
              {/* {editForm ? "Edit user" : "create user"} */}
              Questions Asked
            </Typography>

            <IconButton className="close-filter" onClick={handleDrawerClose}>
              <CloseIcon />
            </IconButton>
          </Box>
        </Box>
        <Grid
          sx={{ p: 2 }}
          item
          className={isLoading ? "loader user-form" : "user-form"}
        >
          <List sx={{ width: "100%", bgcolor: "background.paper" }}>
            {listItems.map((_, i) => (
              <>
                <ListItem alignItems="flex-start">
                  <ListItemAvatar>
                    <ThumbUpOffAltIcon
                      style={{
                        color: "#038229",
                      }}
                    />
                    {/* <Avatar
                      alt="Remy Sharp"
                      src="/static/images/avatar/1.jpg"
                    /> */}
                  </ListItemAvatar>
                  <ListItemText
                    primary={
                      <Typography sx={{ fontSize: "14px" }}>
                        Camera pairing issue on this weekend? Camera pairing
                        issue on this weekend?
                      </Typography>
                    }
                    secondary={
                      <React.Fragment>
                        <Typography
                          sx={{ display: "inline", fontSize: "12px" }}
                          component="span"
                          variant="body2"
                          color="text.secondary"
                        >
                          Ali Connors{" "}
                          {
                            " — I'll be in your neighborhood doing errands this…"
                          }
                        </Typography>
                      </React.Fragment>
                    }
                  />
                </ListItem>
                <Divider variant="inset" component="li" />
                <ListItem alignItems="flex-start">
                  <ListItemAvatar>
                    <ThumbDownOffAltIcon
                      style={{
                        color: "#ed705e",
                      }}
                    />
                    {/* <Avatar
                      alt="Travis Howard"
                      src="/static/images/avatar/2.jpg"
                    /> */}
                  </ListItemAvatar>
                  <ListItemText
                    primary={
                      <Typography sx={{ fontSize: "14px" }}>
                        Clarity issue ?
                      </Typography>
                    }
                    secondary={
                      <React.Fragment>
                        <Typography
                          sx={{ display: "inline", fontSize: "12px" }}
                          component="span"
                          variant="body2"
                          color="text.secondary"
                        >
                          Ali Connors{" "}
                          {
                            " — I'll be in your neighborhood doing errands this…"
                          }
                        </Typography>
                      </React.Fragment>
                    }
                  />
                </ListItem>
                <Divider variant="inset" component="li" />
              </>
            ))}
          </List>
          {/* {isFetching && "Fetching more list items..."} */}
          {isFetching && (
            <div className="chart-item pagination-loader articles"></div>
          )}
        </Grid>
        <Snackbar
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
          open={alertOpen}
          autoHideDuration={2000}
          onClose={handleAlertClose}
        >
          <Alert onClose={handleAlertClose} severity="success">
            {snackbarMessage}
          </Alert>
        </Snackbar>
        <Snackbar
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
          open={errorAlertOpen}
          autoHideDuration={2000}
          onClose={handleErrorAlertClose}
        >
          <Alert onClose={handleErrorAlertClose} severity="error">
            {snackbarMessage}
          </Alert>
        </Snackbar>
      </Drawer>
    </Grid>
  );
};

export default React.memo(ArticleQuesopen);
